import React from 'react'
import OperatorFormWrap from '../../../Components/Organisms/Operators/OperatorFormWrap'

function AddOperatorTemplate({formik}) {
  return (
    <OperatorFormWrap formik={formik} />
  )
}

export default AddOperatorTemplate